import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { StatusPill } from "./StatusPill";

/**
 * RelatedTaskRow — linha clicável pra exibir relação parent/child entre
 * issues. Usado em TaskInfoPanel (Resultado), em listas de sub-tarefas
 * (Quadro inline), e qualquer outro lugar que mostre tarefa relacionada.
 *
 * Props ficam minimal — recebe os campos diretos pra ser agnóstica do
 * Issue type completo (cuida do roteamento direto).
 */

export function RelatedTaskRow({
  id,
  title,
  status,
  identifier,
  size = "md",
}: {
  id: string;
  title: string;
  status: string;
  identifier?: string | null;
  size?: "sm" | "md";
}) {
  // Done/in_review abrem o entregável; demais vão pra execução
  const target =
    status === "done" || status === "in_review"
      ? `/resultado/${id}`
      : `/execucao/${id}`;

  const padding = size === "sm" ? "6px 8px" : "8px 10px";
  const fontSize = size === "sm" ? 11 : 12;

  return (
    <Link
      to={target}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding,
        borderRadius: 8,
        textDecoration: "none",
        color: "inherit",
        border: "1px solid var(--wf-ink-5)",
        background: "var(--wf-paper)",
        transition: "border-color 120ms",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--nd-orange)")}
      onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--wf-ink-5)")}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize,
            fontWeight: 600,
            color: "var(--wf-ink)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            lineHeight: 1.3,
          }}
        >
          {title}
        </div>
        <div style={{ marginTop: 3, display: "flex", gap: 6, alignItems: "center" }}>
          <StatusPill status={status} size="sm" />
          {identifier && (
            <span style={{ fontSize: 10, color: "var(--wf-ink-3)" }}>
              {identifier}
            </span>
          )}
        </div>
      </div>
      <ChevronRight size={12} strokeWidth={2} color="var(--wf-ink-3)" />
    </Link>
  );
}
